import { useState } from 'react'

import { HiOutlineClipboardCopy } from 'react-icons/hi'

import { Box, Code, Text } from '@chakra-ui/react'

import { Button } from '../Button'

export interface SecretArnStepIProps {
  secretArn: string
  secretTemplate?: string
  onClose: () => void
}

export const SecretArnStep = ({
  secretArn,
  secretTemplate,
  onClose,
}: SecretArnStepIProps) => {
  const [hasCopied, setHasCopied] = useState(false)
  const [hasCopiedTemplate, setHasCopiedTemplate] = useState(false)

  const onCopy = async () => {
    await navigator.clipboard.writeText(secretArn)
    setHasCopied(true)
    setTimeout(() => setHasCopied(false), 2000)
  }

  const onCopyTemplate = async () => {
    await navigator.clipboard.writeText(secretTemplate)
    setHasCopiedTemplate(true)
    setTimeout(() => setHasCopiedTemplate(false), 2000)
  }

  return (
    <Box py={2}>
      <Text fontWeight='semibold' mb={2}>
        Create your AWS secret
      </Text>
      <Text color='gray.600' fontSize='sm' mb={4}>
        Create an AWS Secrets Manager secret in your account using this ARN.
        HiveWatch will use it to retrieve credentials.
      </Text>
      <Box
        bg='gray.50'
        border='1px solid'
        borderColor='gray.200'
        borderRadius='md'
        mb={2}
        overflowX='auto'
        p={4}
      >
        <Code bg='transparent' display='block' fontSize='xs' whiteSpace='pre'>
          {secretArn}
        </Code>
      </Box>
      <Box display='flex' justifyContent='flex-end' mb={4}>
        <Button
          leftIcon={<HiOutlineClipboardCopy size='20px' />}
          onClick={onCopy}
          variant='secondary'
        >
          {hasCopied ? 'Copied!' : 'Copy ARN'}
        </Button>
      </Box>
      {secretTemplate && (
        <>
          <Text color='gray.500' fontSize='xs' fontWeight='semibold' mb={1}>
            Secret JSON structure
          </Text>
          <Text color='gray.600' fontSize='sm' mb={2}>
            Use this structure as the value of your AWS secret.
          </Text>
          <Box
            bg='gray.50'
            border='1px solid'
            borderColor='gray.200'
            borderRadius='md'
            mb={2}
            overflowX='auto'
            p={4}
          >
            <Code
              bg='transparent'
              display='block'
              fontSize='xs'
              whiteSpace='pre'
            >
              {secretTemplate}
            </Code>
          </Box>
          <Box display='flex' justifyContent='flex-end' mb={4}>
            <Button
              leftIcon={<HiOutlineClipboardCopy size='20px' />}
              onClick={onCopyTemplate}
              variant='secondary'
            >
              {hasCopiedTemplate ? 'Copied!' : 'Copy JSON'}
            </Button>
          </Box>
        </>
      )}
      <Box display='flex' justifyContent='flex-end'>
        <Button onClick={onClose}>Done</Button>
      </Box>
    </Box>
  )
}
